import clsx from 'clsx';
import { Icon as LucideIcon } from 'lucide-react';
import { Icon } from '../Icon/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
const iconNode = [['path', {
  d: 'M16.131 10.5a1 1 0 0 0 .832-1.555l-4.13-6.197a1 1 0 0 0-1.665 0L7.037 8.945a1 1 0 0 0 .832 1.555z',
  key: '1ohhfa'
}], ['circle', {
  cx: '17.5',
  cy: '17.5',
  r: '4.2',
  key: 'nglu0q'
}], ['rect', {
  x: '2.5',
  y: '13.5',
  width: '8',
  height: '8',
  rx: '2',
  key: '18fh1k'
}]];
export function ProductOther({
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Icon, {
    icon: LucideIcon,
    iconNode: iconNode,
    className: clsx('lucide-custom-product-other', className),
    ...extraProps
  });
}